import { render, staticRenderFns } from "./date-bought-notification.vue?vue&type=template&id=2225cab8&scoped=true&"
import script from "./date-bought-notification.vue?vue&type=script&lang=js&"
export * from "./date-bought-notification.vue?vue&type=script&lang=js&"
import style0 from "./date-bought-notification.vue?vue&type=style&index=0&id=2225cab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225cab8",
  null
  
)

export default component.exports